var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_1363_739)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99998 1.83325C4.59422 1.83325 1.83331 4.59416 1.83331 7.99992C1.83331 9.61408 2.45303 11.0831 3.46863 12.1826C4.34669 10.5842 6.04622 9.49992 7.99998 9.49992C9.95374 9.49992 11.6533 10.5842 12.5313 12.1826C13.5469 11.0831 14.1666 9.61408 14.1666 7.99992C14.1666 4.59416 11.4057 1.83325 7.99998 1.83325ZM11.7668 12.8829C11.0982 11.4735 9.66222 10.4999 7.99998 10.4999C6.33774 10.4999 4.9018 11.4735 4.2332 12.8829C5.27517 13.688 6.58116 14.1666 7.99998 14.1666C9.4188 14.1666 10.7248 13.688 11.7668 12.8829ZM0.833313 7.99992C0.833313 4.04188 4.04194 0.833252 7.99998 0.833252C11.958 0.833252 15.1666 4.04188 15.1666 7.99992C15.1666 10.1596 14.2107 12.0966 12.7006 13.4098C11.4426 14.5037 9.79807 15.1666 7.99998 15.1666C6.20188 15.1666 4.55736 14.5037 3.29933 13.4098C1.78923 12.0966 0.833313 10.1596 0.833313 7.99992ZM5.49998 5.99992C5.49998 4.61921 6.61927 3.49992 7.99998 3.49992C9.38069 3.49992 10.5 4.61921 10.5 5.99992C10.5 7.38063 9.38069 8.49992 7.99998 8.49992C6.61927 8.49992 5.49998 7.38063 5.49998 5.99992ZM7.99998 4.49992C7.17155 4.49992 6.49998 5.17149 6.49998 5.99992C6.49998 6.82835 7.17155 7.49992 7.99998 7.49992C8.82841 7.49992 9.49998 6.82835 9.49998 5.99992C9.49998 5.17149 8.82841 4.49992 7.99998 4.49992Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1363_739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.870940ae497aa4f2707aa817c8bb381d.svg";
export { ForwardRef as ReactComponent };